<template>
  <div class="register-container">
    <div class="register-card">
      <div class="register-header">
        <h2 class="register-title">物业注册</h2>
        <p class="register-subtitle">请填写以下信息完成注册</p>
      </div>

      <el-form ref="registerForm" :model="registerInfo" label-width="0" class="register-form">
        <!-- 地区选择 -->
        <el-form-item>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-select v-model="registerInfo.selectProv" @change="getProv" placeholder="请选择省" style="width:100%" class="custom-select">
                <el-option v-for="(item, index) in registerInfo.provs" :key="index" :label="item.areaName"
                  :value="item.areaCode">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select v-model="registerInfo.selectCity" @change="getCity" placeholder="请选择城市" style="width:100%" class="custom-select">
                <el-option v-for="(item, index) in registerInfo.citys" :key="index" :label="item.areaName"
                  :value="item.areaCode">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select v-model="registerInfo.selectArea" @change="getArea" placeholder="请选择区县" style="width:100%" class="custom-select">
                <el-option v-for="(item, index) in registerInfo.areas" :key="index" :label="item.areaName"
                  :value="item.areaCode">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>

        <!-- 物业名称 -->
        <el-form-item>
          <el-input v-model="registerInfo.shopName" placeholder="请输入物业名称" class="custom-input">
          </el-input>
        </el-form-item>

        <!-- 物业类型 -->
        <el-form-item>
          <el-select v-model="registerInfo.shopType" placeholder="请选择物业类型" style="width:100%" class="custom-select">
            <el-option v-for="(item, index) in registerInfo.shopTypes" :key="index" :label="item.typeName"
              :value="item.shopTypeId">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 密码 -->
        <el-form-item>
          <el-input v-model="registerInfo.passwd" placeholder="请输入密码" type="password" maxlength="20" show-password
            class="custom-input">
          </el-input>
        </el-form-item>

        <!-- 注册按钮 -->
        <el-form-item>
          <el-button type="primary" @click="doRegister" class="register-button">
            注册
          </el-button>
        </el-form-item>

        <!-- 登录链接 -->
        <div class="login-link">
          <span>已有账号？</span>
          <el-link type="primary" @click="handleLogin">立即登录</el-link>
        </div>
      </el-form>
    </div>
    
    <init-data ref="initData"></init-data>
  </div>
</template>

<script>
import initData from '@/components/frame/initData/initData'
import { wuyeRegister, listShopTypes, listAreas,pcCodeUserLogin } from '@/api/frame/wuyeRegisterApi'
import { getSysInfo } from '@/api/frame/loginApi'

export default {
  name: 'WuyeRegister',
  components: {
    initData
  },
  data() {
    return {
      registerInfo: {
        code: '',
        shopName: '',
        passwd: '',
        logo: '',
        areas: [],
        provs: [],
        citys: [],
        selectProv: '',
        selectCity: '',
        selectArea: '',
        areaAddress: '',
        areaCode: '',
        shopType: '',
        shopTypes: [],
      }
    }
  },
  created() {
    this.registerInfo.code = this.$route.query.code
    this._initSysInfo()
    this._initArea('101', '0')
    this._listShopTypes()
  },
  methods: {
   async _initSysInfo() {
      const res = await getSysInfo()
      this.registerInfo.logo = res.logo
    },
    validate() {
      if (!this.registerInfo.shopName) {
        this.$message.error('物业名称不能为空')
        return false
      }
      if (!this.registerInfo.passwd) {
        this.$message.error('密码不能为空')
        return false
      }
      if (!this.registerInfo.areaCode) {
        this.$message.error('地区不能为空')
        return false
      }
      if (!this.registerInfo.shopType) {
        this.$message.error('物业类型不能为空')
        return false
      }
      return true
    },
    async doRegister() {
      if (!this.validate()) return

      const params = {
        code: this.registerInfo.code,
        shopName: this.registerInfo.shopName,
        password: this.registerInfo.passwd,
        areaAddress: this.registerInfo.areaAddress,
        areaCode: this.registerInfo.areaCode,
        shopType: this.registerInfo.shopType,
      }

      const res = await wuyeRegister(params)
      if (res.code === 0) {
        this.$message.success('注册成功！')
        this.registerLogin(res.data)
      } else {
        this.$message.error(res.msg)
      }
    },
   async registerLogin(code) {
      const res = await pcCodeUserLogin({ code })
      if (res.code && res.code !== '0') {
        this.$message.error(res.msg)
        return
      }
      localStorage.setItem('token', res.token)
      this.$refs.initData.loadShopInfo({ url: '/views/index/index' })
    },
    getProv(prov) {
      this._initArea('202', prov)
      this.registerInfo.selectCity = ''
      this.registerInfo.selectArea = ''
      this.registerInfo.citys = []
      this.registerInfo.areas = []
    },
    getCity(city) {
      this._initArea('303', city)
      this.registerInfo.selectArea = ''
      this.registerInfo.areas = []
    },
    getArea(area) {
      this.registerInfo.areaAddress = ''
      this.registerInfo.areaCode = area

      if (!this.registerInfo.provs) return

      const prov = this.registerInfo.provs.find(p => p.areaCode === this.registerInfo.selectProv)
      if (prov) this.registerInfo.areaAddress = prov.areaName

      const city = this.registerInfo.citys.find(c => c.areaCode === this.registerInfo.selectCity)
      if (city) this.registerInfo.areaAddress += city.areaName

      const areaObj = this.registerInfo.areas.find(a => a.areaCode === this.registerInfo.selectArea)
      if (areaObj) this.registerInfo.areaAddress += areaObj.areaName
    },
    _initArea(areaLevel, parentAreaCode) {
      listAreas({ areaLevel, parentAreaCode }).then(res => {
        const areas = res.data || []
        if (areaLevel === '101') {
          this.registerInfo.provs = areas
        } else if (areaLevel === '202') {
          this.registerInfo.citys = areas
        } else {
          this.registerInfo.areas = areas
        }
      }).catch(() => {
        this.$message.error('查询地区失败')
      })
    },
    _listShopTypes() {
      listShopTypes({ page: 1, row: 100 }).then(res => {
        this.registerInfo.shopTypes = res.data || []
      }).catch(() => {
        this.$message.error('获取物业类型失败')
      })
    },
    handleLogin() {
      this.$router.push('/views/frame/login')
    }
  }
}
</script>

<style scoped>
.register-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.register-card {
  width: 100%;
  max-width: 600px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  padding: 40px;
}

.register-header {
  text-align: center;
  margin-bottom: 30px;
}

.register-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 10px;
}

.register-subtitle {
  font-size: 14px;
  color: #6b7280;
}

.register-form {
  margin-bottom: 20px;
}

.custom-input>>>.el-input__inner {
  height: 50px;
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  background: #f9fafb;
  font-size: 14px;
  transition: all 0.3s ease;
}

.custom-input>>>.el-input__inner:focus {
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.custom-select>>>.el-input__inner {
  height: 50px;
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  background: #f9fafb;
  font-size: 14px;
  transition: all 0.3s ease;
}

.custom-select>>>.el-input__inner:focus {
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.register-button {
  width: 100%;
  height: 50px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  transition: all 0.3s ease;
}

.register-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
}

.register-button:active {
  transform: translateY(0);
}

.login-link {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #6b7280;
}

.login-link .el-link {
  margin-left: 5px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .register-container {
    padding: 10px;
  }

  .register-card {
    padding: 30px 20px;
  }

  .register-title {
    font-size: 24px;
  }
}
</style>